import React from 'react';
import styled from 'styled-components';
import Preview from './Preview';

function ContactUS() {
  
  return (
    <ContentWrapper>
      <Title className='mb-2'>Click button to edit Contact Us page</Title> 
      <Preview/>    
    </ContentWrapper>
  );
}

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
     @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 5px 0;
`;

export default ContactUS;